export default "<input style=\"width: 100%;\" type=\"text\" name=\"\" [(ngModel)]=\"rowData.questionNumber\" (change)=\"valueChanged()\">\n"